import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { DowngradeRequest, DowngradeResponse, downgrade } from '@utils/backend-api/downgrade';

export default function useDowngrade() {
  const { mutate, isLoading, isError } = useMutation(
    (values: DowngradeRequest) => downgrade(values),
    {
      onSuccess: (data: DowngradeResponse) => {
        if (data.success) {
          window.location.href = data.redirectUri;
        }
      },
      onError: (data: DowngradeResponse) => {
        toast.error(data?.message ?? 'Your downgrade update failed, please try again later');
      },
    }
  );
  return { mutate, isLoading, isError };
}
